// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import en from './locales/en.json';
// import zh from './locales/zh.json';

// // Function to get URL query parameter
// const getQueryParam = (param) => {
//     const urlParams = new URLSearchParams(window.location.search);
//     return urlParams.get(param);
//   };
  
// // Function to detect and return the appropriate language
// const detectLanguage = () => {
//     const supportedLanguages = ['en-US', 'zh-HK']; // Define supported specific languages
  
//     // Check for ?lang parameter in the URL
//     const langParam = getQueryParam('lang');
  
//     // If there's a valid ?lang param, use it
//     if (langParam && supportedLanguages.includes(langParam)) {
//       return langParam;
//     }
  
//     // Fall back to browser language if no valid ?lang parameter is present
//     const browserLang = navigator.language || navigator.userLanguage; // Get browser language
  
//     if (supportedLanguages.includes(browserLang)) {
//       return browserLang;
//     }
  
//     // If browserLang is zh-HK, zh-TW, or any Chinese variant, map to a common zh.json
//     if (browserLang.startsWith('zh')) {
//         return 'zh-HK';
//     }
  
//     return 'en-US'; // Default to 'en' if no valid language is found
//   };

// i18n
//   .use(initReactI18next)
//   .init({
//     resources: {
//       en: {
//         translation: en,
//       },
//       zh: {
//         translation: zh,
//       },
//     },
//     lng: detectLanguage(), // language to use
//     fallbackLng: 'en', // fallback language if translation is missing
//     interpolation: {
//       escapeValue: false, // react already safe from XSS
//     },
//   });

// export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enReceipt from "./locales/en.json";
import zhReceipt from "./locales/zh.json";
import enWebReceipt from "./components/web-receipt/locales/env2.json";
import zhWebReceipt from "./components/web-receipt/locales/zhv2.json";
import enTripPayment from "./locales/tripPayment/en.json";
import zhTripPayment from "./locales/tripPayment/zh.json";
import enPaymentPage from "./components/PaymentPage/locales/en.json";
import zhPaymentPage from "./components/PaymentPage/locales/zh.json";
import enFlightAlerts from "./components/FlightAlerts/locales/en.json";

const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

const detectLanguage = () => {
  // Accepts en, en-US, zh, zh-HK, zh-TW, etc.
  const langParam = getQueryParam("lang");
  if (langParam) {
    if (langParam.toLowerCase().startsWith("zh")) return "zh";
    if (langParam.toLowerCase().startsWith("en")) return "en";
  }
  const browserLang = navigator.language || navigator.userLanguage || "en";
  if (browserLang.toLowerCase().startsWith("zh")) return "zh";
  if (browserLang.toLowerCase().startsWith("en")) return "en";
  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      receipt: enReceipt,
      webReceipt: enWebReceipt,
      tripPayment: enTripPayment,
      paymentPage: enPaymentPage,
      flightAlerts: enFlightAlerts,
    },
    zh: {
      receipt: zhReceipt,
      webReceipt: zhWebReceipt,
      tripPayment: zhTripPayment,
      paymentPage: zhPaymentPage,
    },
  },
  lng: detectLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  ns: ["receipt", "webReceipt", "tripPayment", "paymentPage", "flightAlerts"],
  defaultNS: "receipt",
});

export default i18n;